import { render, staticRenderFns } from "./layout-favorite-button.vue?vue&type=template&id=6972d668&scoped=true&"
import script from "./layout-favorite-button.vue?vue&type=script&lang=js&"
export * from "./layout-favorite-button.vue?vue&type=script&lang=js&"
import style0 from "./layout-favorite-button.vue?vue&type=style&index=0&id=6972d668&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6972d668",
  null
  
)

export default component.exports